import { getAdminDashboardData } from "../../../Redux/Dashboard/DashboardActions";
import Chart from "../../../Components/Admin/Dashboard/Chart/Chart";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Dashboard.module.scss";
import { Link } from "react-router";
import { useEffect } from "react";

function Dashboard() {
  const dispatch = useDispatch<AppDispatch>();
  const { adminData, adminLoading } = useSelector(
    (state: RootState) => state.dashboard,
  );

  useEffect(() => {
    dispatch(getAdminDashboardData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (adminLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Dashboard</h1>
      </div>
      <div className={styles.statsContainer}>
        <Link to="/admin/buildings" className={styles.stats}>
          <h2 className={styles.value}>{adminData?.totalBuildingCount}</h2>
          <p className={styles.label}>Building</p>
        </Link>
        <Link to="/admin/members" className={styles.stats}>
          <h2 className={styles.value}>{adminData?.totalMemberCount}</h2>
          <p className={styles.label}>Members</p>
        </Link>
        <Link to="/admin/reports/profit" className={styles.stats}>
          <h2 className={styles.value}>${adminData?.totalRevenue}</h2>
          <p className={styles.label}>Revenue</p>
        </Link>
      </div>
      <div className={styles.chartsContainer}>
        <div className={styles.chartContainer}>
          <div className={styles.chartHeadingContainer}>
            <h2 className={styles.chartHeading}>Revenue</h2>
          </div>
          <div className={styles.chart}>
            <Chart data={adminData?.monthlyPayments} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
